import { useEffect, useState } from "react";
import { CloseGreyIcon, CloseRedIcon } from "../../../assets/icons";
import { useNotification } from "../../toster-notification/NotificationContext";
import { SelectLocationAreaDTO } from "../../../models/locationArea/locationArea.response";
import { SelectCityDataDTO } from "../../../models/city/city.response";
import { locationAreaService } from "../../../services/locationAreaService";
import { cityService } from "../../../services/cityService";
import { nameToSlug } from "../../../utils/slugService";
import Loader from "../../shared/Loader";


interface AddLocationAreaViewProps {
    onClose: () => void;
}

export default function AddLocationAreaView({ onClose }: AddLocationAreaViewProps) {

    const [name, setName] = useState("");
    const [nameError, setNameError] = useState("");
    const [slug, setSlug] = useState("");
    const [slugError, setSlugError] = useState("");
    const [cityId, setCityId] = useState("");
    const [cityIdError, setCityIdError] = useState("");
    const [cities, setCities] = useState<SelectCityDataDTO[]>([]);
    const [imageFile, setImageFile] = useState<File | null>(null);

    const [loading, setLoading] = useState<boolean>(false);
    const { notify } = useNotification();


    useEffect(() => {
        fetchCities();
    }, []);


    const fetchCities = async () => {
        setLoading(true);
        try {
            const response = await cityService.GetForSelect();

            if (response.success && response.data) {
                setCities(response.data);
            } else {
                notify("error", "Error Fetching Cities", "An error occurred while fetching cities.");
            }
        } catch (error) {
            console.error("Error fetching cities:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleCreateLocationArea = async () => {
        setNameError("");
        setSlugError("");
        setCityIdError("");

        let isValid = true;

        if (!name.trim()) {
            setNameError("Name is required.");
            isValid = false;
        }

        if (!slug.trim()) {
            setSlugError("Slug is required.");
            isValid = false;
        }

        if (!cityId) {
            setCityIdError("City is required.");
            isValid = false;
        }

        if (!isValid) {
            return;
        }

        setLoading(true);
        try {

            let formData = new FormData();
            formData.append("name", name);
            formData.append("slug", slug);
            formData.append("cityId", cityId);

            if (imageFile) {
                formData.append("imageFile", imageFile);
            }

            const response = await locationAreaService.Create(formData);
            if (response.success) {
                notify("success", "Location Area Created", "The location area has been created successfully.");
                onClose();
            } else {
                notify("error", "Error Creating Location Area", response.message || "An error occurred while creating the location area.");
            }
        } catch (error) {
            notify("error", "Error Creating Location Area", "An error occurred while creating the location area.");
        }
        finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <Loader />;
    }

    return (
        <section className="modal-section">
            <div className="w-layout-blockcontainer container w-container">
                <div className="modal-wrapper">
                    <div className="modal-div">
                        <div className="modal-header-div">
                            <div>
                                <div className="modal-header">Dodaj Novu Lokaciju</div>
                                <div className="description-text">Unesite podatke o lokaciji</div>
                            </div>
                            <div className="modal-button-div" onClick={onClose}>
                                <img loading="lazy" src={CloseGreyIcon} alt="" className="icon-size-20 close" />
                            </div>
                        </div>
                        <div className="modal-form-block w-form">
                            <form className="modal-form">

                                <div className="modal-form-div">
                                    <label className="modal-form-label">Grad *</label>
                                    <select className="form-select auto-width w-select" value={cityId} onChange={(e) => setCityId(e.target.value)} >
                                        <option value="">Select one...</option>
                                        {cities.map((city) => (
                                            <option key={city.id} value={city.id}>
                                                {city.name}
                                            </option>
                                        ))}
                                    </select>
                                    <div className="error-text">{cityIdError}</div>
                                </div>

                                <div className="modal-form-div">
                                    <label className="modal-form-label">Upload slike</label>
                                    <input className="" style={{ alignContent: "" }} type="file"
                                        onChange={(e) => {
                                            if (e.target.files && e.target.files.length > 0) {
                                                setImageFile(e.target.files[0]);
                                            }
                                        }}
                                    />
                                    <div className="modal-image-div">
                                        <img src={imageFile ? URL.createObjectURL(imageFile) : ""} loading="lazy" className="modal-image" />
                                        <div className="modal-image-remove-div"
                                            onClick={() => {
                                                setImageFile(null);
                                            }}
                                        >
                                            <img loading="lazy" src={CloseRedIcon} alt="" className="icon-size-16 pointer" />
                                        </div>
                                    </div>
                                </div>

                                <div className="modal-form-div">
                                    <label className="modal-form-label">Naziv Lokacije *</label>
                                    <input className="form-input grey w-input" placeholder="Liman 1" type="text"
                                        value={name}
                                        onChange={(e) => {
                                            setName(e.target.value);
                                            setSlug(nameToSlug(e.target.value));
                                        }}
                                    />
                                    <div className="error-text">{nameError}</div>
                                </div>
                                <div className="modal-form-div">
                                    <label className="modal-form-label">Slug</label>
                                    <input className="form-input grey w-input" placeholder="liman-1" type="text"
                                        value={slug}
                                        onChange={(e) => setSlug(e.target.value)}
                                    />
                                    <div className="error-text">{slugError}</div>
                                </div>
                            </form>
                        </div>
                        <div className="modal-buttons">
                            <div className="button-secondary medium" onClick={onClose}>
                                <div>Otkaži</div>
                            </div>
                            <div className="button-primary medium" onClick={handleCreateLocationArea}>
                                <div>Kreiraj Lokaciju</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    );
}